<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb" v-if="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="d-none d-xl-block col-xl-3">
                    <catalog-categories></catalog-categories>
                </div>

                <div class="col-xl-9">
                    <div v-if="singleNews">
                        <div class="box-shadow mb-40">
                            <div class="mb-24" v-if="singleNews.big_image">
                                <img :src="'/storage/' + singleNews.big_image" alt="" class="img-fluid">
                            </div>
                            <h1 class="as-h2 mb-40">{{ singleNews.title.en }}</h1>
                            <div class="editor-show" v-html="singleNews.long_desc.en"></div>
                        </div>

                        <div v-if="newsLatest && newsLatest.length > 0">
                            <span class="title-2 mb-28">Вас также может заинтересовать:</span>

                            <div class="grid-container" v-if="newsLatest">
                                <router-link class="box-grid" v-for="item in newsLatest"
                                             v-bind:key="newsLatest.id"
                                             :to="'/news/' + item.slug.en">
                                    <img :src="'/storage/' + item.image" :alt="item.title.en" class="img-fluid">
                                    <!--                                    <img src="/img/del/1.jpg" alt="">-->
                                    <span class="title-4 color-text-white">{{ item.title.en }}</span>
                                </router-link>
                            </div>
                        </div>

                    </div>

                    <div v-if="loading" class="loading-box">
                        <b-spinner></b-spinner>
                    </div>

                    <div class="mt-5" v-if="seo_text">
                        <p v-html="seo_text"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            loading: true,

            singleNews: null,
            newsLatest: null,


            breadcrumb: null,

            seo_text: null
        }
    },

    watch: {
        $route() {
            this.loading = true;
            this.init();
        },
    },

    mounted() {
        this.init()
    },

    methods: {
        init() {
            this.singleNews = null;
            this.newsLatest = null;


            let url = '/api/news/show';
            let slug = this.$route.params.slug;
            axios.post(url, {'slug': slug})
                .then(response => {
                    this.singleNews = response.data.singleNews;
                    this.newsLatest = response.data.newsLatest;
                    this.getBreadcrumb();
                    this.loading = false;

                    this.seo_text = this.singleNews.seo_text
                    document.title = this.singleNews.seo_title ? this.singleNews.seo_title : this.singleNews.title.en + ' - Фотопрокат MRental';
                    let desc = this.singleNews.seo_desc ? this.singleNews.seo_desc : this.singleNews.title.en + '. Следите за новостями поставок новой техники и оборудования, а также спецпроектов.';
                    document.querySelector('meta[name="description"]').setAttribute("content", desc);
                    document.querySelector('meta[name="twitter:description"]').setAttribute("content", desc);
                    document.querySelector('meta[property="og:description"]').setAttribute("content", desc);
                    document.querySelector('meta[name="twitter:text:description"]').setAttribute("content", desc);
                })
                .catch(error => {
                    window.location.href = '/404';
                    if (error) this.loading = false;
                })
        },

        getBreadcrumb() {
            this.breadcrumb = [
                {
                    text: 'Главная',
                    to: {name: 'pages-index'}
                },
                {
                    text: 'Новости',
                    to: {name: 'pages-news'}
                },
                {
                    text: this.singleNews.title.en,
                    active: true
                }
            ]

        }
    }
}
</script>

